/* eslint-disable no-unused-vars */
const ForgePotree = window.ForgePotree;
import store from '@/store';
import { log as debugLog, error as debugError } from '@/utils/debugLogger';

export const MEASUREMENT = {
    state: {
        isMeasuring: false,
        isMeasuringArea: false,
        isMeasuringInPanorama: false,
        openedPointCloudForMeasuring: "",
        closedPointCloudForMeasuring: [],
        croppedMeasurementDialog: {
            visible: false,
            cropBox: null,
            pointCloudUrl: null,
            pointCloudName: null,
            forgePCInstance: null,
            unitScale: null,
            globalOffset: null,
            analysisResult: null,
            tagId: null
        },
    },

    mutations: {
        SET_IS_MEASURING : (state, value) => {
            state.isMeasuring = value;
        },
        SET_IS_MEASURING_AREA : (state, value) => {
            state.isMeasuringArea = value;
        },
        SET_IS_MEASURING_IN_PANORAMA : (state, value) => {
            state.isMeasuringInPanorama = value;
        },
        SET_OPENED_PC_FOR_MEASURING : (state, value) => {
            state.openedPointCloudForMeasuring = value;
        },
        SET_CLOSED_PC_FOR_MEASURING : (state, value) => {
            state.closedPointCloudForMeasuring = value;
        },
        SET_CROPPED_MEASUREMENT_DIALOG : (state, payload) => {
            state.croppedMeasurementDialog = {
                visible: payload.visible,
                cropBox: payload.cropBox,
                pointCloudUrl: payload.pointCloudUrl,
                pointCloudName: payload.pointCloudName,
                pointCloudId: payload.pointCloudId,
                forgePCInstance: payload.forgePCInstance,
                unitScale: payload.unitScale,
                globalOffset: payload.globalOffset,
                modelGlobalOffset: payload.modelGlobalOffset,
                analysisResult: payload.analysisResult,
                tagId: payload.tagId
            };

            debugLog('[MeasurementStore] SET_CROPPED_MEASUREMENT_DIALOG:', state.croppedMeasurementDialog);
        },
        CLEAR_CROPPED_MEASUREMENT_DIALOG : (state) => {
            state.croppedMeasurementDialog = {
                visible: false,
                cropBox: null,
                pointCloudUrl: null,
                pointCloudName: null,
                forgePCInstance: null,
                unitScale: null,
                globalOffset: null,
                analysisResult: null,
                tagId: null
            };
        }
    },

    actions: {
        OPEN_PC_FOR_MEASURING({ commit, state, getters }, value) {
            // Fast path: clearing, or the same PC is already open → just record the id.
            // (Preserves the old mutation's `if (value && opened == value) return` guard.)
            if (!value || state.openedPointCloudForMeasuring === value) {
                commit('SET_OPENED_PC_FOR_MEASURING', value);
                return;
            }
            // Hide every OTHER currently-visible point cloud while measuring this one, and
            // remember them so CLOSE_LOADED_PC_FOR_360_MEASURING can restore them afterwards.
            // (This side-effect previously lived inside the mutation — project rules #5/#8.)
            const pcForClose = Array.from(
                store.state.forgeService?.getMainExtension()?._pointCloudGroups
                    .filter(p => p.visible)?.keys().filter(k => k != value) ?? []
            );
            if (pcForClose?.length) {
                const pcs = getters["getPointClouds"].filter(p => pcForClose.includes(p.name));
                pcs.forEach(pc => store.state.forgeService.setShowingPointCloudIn3D(pc, false));
            }
            commit('SET_CLOSED_PC_FOR_MEASURING', pcForClose);
            commit('SET_OPENED_PC_FOR_MEASURING', value);
        },
        CLOSE_LOADED_PC_FOR_360_MEASURING({ dispatch, commit, state, getters }) {
            let pcName = getters['GET_OPENED_PC_FOR_MEASURING'];
            debugLog("CLOSE_LOADED_PC_FOR_360_MEASURING", pcName);
            if (pcName) {
                commit('SET_OPENED_PC_FOR_MEASURING', "");
                let pc = getters["getPointClouds"].find(p => p.name == pcName);                
                store.state.forgeService.toggleShowingPointCloudIn3D(pc);
            }

            let pcForOpen = state.closedPointCloudForMeasuring;
            if (pcForOpen?.length) {
                let pcs = getters["getPointClouds"].filter(p => pcForOpen.includes(p.name));
                pcs.forEach(pc => {
                    store.state.forgeService.setShowingPointCloudIn3D(pc, true);
                });
                commit('SET_CLOSED_PC_FOR_MEASURING', []);
            }
            // store.state.userSettings.displaySettings.pointCloudDisplay.pointBudget = 1e8;
            // store.state.userSettings.displaySettings.pointCloudDisplay.pointSize = 3;
            ForgePotree.Global.boundingBoxStrict = null;
        },
    },

    getters: {
        GET_IS_MEASURING : (state) => {
            return state.isMeasuring;
        },
        GET_IS_MEASURING_AREA : (state) => {
            return state.isMeasuringArea;
        },
        GET_IS_MEASURING_IN_PANORAMA : (state) => {
            return state.isMeasuringInPanorama;
        },
        GET_OPENED_PC_FOR_MEASURING : (state) => {
            return state.openedPointCloudForMeasuring;
        },
        GET_CROPPED_MEASUREMENT_DIALOG : (state) => {
            return state.croppedMeasurementDialog;
        }
    },
}